export let audioContext
let micStartBuffer
let micCloseBuffer

export async function preloadAudio() {
  try {
    audioContext = new (window.AudioContext)();

    const micStartResponse = await fetch('/audios/start_rec.mp3');
    const micStartArrayBuffer = await micStartResponse.arrayBuffer();
    micStartBuffer = await audioContext.decodeAudioData(micStartArrayBuffer);
    console.log('Mic start sound loaded.');

    const micCloseResponse = await fetch('/audios/stop_rec.mp3');
    const micCloseArrayBuffer = await micCloseResponse.arrayBuffer();
    micCloseBuffer = await audioContext.decodeAudioData(micCloseArrayBuffer);
    console.log('Mic close sound loaded.');
  } catch (error) {
    console.error('Error loading audio buffers:', error);
  }
}

export function playMicStartSound() {
  if (!micStartBuffer) {
    console.warn('Mic start audio buffer is not loaded.');
    return;
  }

  const source = audioContext.createBufferSource();
  source.buffer = micStartBuffer;
  source.connect(audioContext.destination);
  source.start(0);
  console.log('Mic start sound played.');
}

export function playMicCloseSound() {
  if (!micCloseBuffer) {
    console.warn('Mic close audio buffer is not loaded.');
    return;
  }

  const source = audioContext.createBufferSource();
  source.buffer = micCloseBuffer;
  source.connect(audioContext.destination);
  source.start(0);
  console.log('Mic close sound played.');
}